import React from 'react';

import { Card } from '@apigrowfinance/pbolt-card';
import { InactiveUser } from '@apigrowfinance/pbolt-icons';
import IllustratedMessage from '@apigrowfinance/pbolt-illustrated-message';
import { FormattedMessage } from 'react-intl';

import { CustomersItem } from '@clients/customersClient';
import UserRowContainer from '@pages/accountDetail/tabs/users/user/UserRowContainer';

interface UsersProps {
    customerDetails?: CustomersItem[];
    isLoading?: boolean;
    onRefetch?: () => void;
}

const Users = ({ customerDetails = [], isLoading, onRefetch }: UsersProps) => {
    if (!isLoading && customerDetails.length == 0) {
        return (
            <Card isTopRadiusBorder={false}>
                <IllustratedMessage
                    icon={<InactiveUser color="inherit" />}
                    messageMain={
                        <FormattedMessage
                            id="Users.noUsersToShow"
                            defaultMessage="No customers to show"
                        />
                    }
                    messageSub={
                        <FormattedMessage
                            id="Users.thereHaveBeenNoUsersAdded"
                            defaultMessage="There have been no customers added"
                        />
                    }
                />
            </Card>
        );
    }

    if (isLoading && customerDetails.length == 0) {
        // if loading and no data, then create some dummy data to display as skeleton
        customerDetails.push({} as CustomersItem);
    }

    return (
        <>
            {customerDetails?.map((customerDetail, index) => (
                <UserRowContainer
                    key={index}
                    customerId={customerDetail?.customer?.id}
                    isLoading={isLoading}
                    onRefetch={onRefetch}
                />
            ))}
        </>
    );
};

export default Users;
